import styled from 'styled-components';
import { media, Row } from '@simplywallst/ui-core';

export const RowWithGutter = styled(Row)`
  ${media.mdUp`
    flex-wrap: nowrap;
    & > * + * {
        margin-left: ${({ theme }) => theme.x4spacePx}px;
    }
  `}
`;
